import React from 'react'
import { DefaultJoinFormPageProps } from 'src/pages/DefaultJoinFormPage'
import { UIInfoSpace } from 'src/types/api'
import RenderIf from 'src/components/RenderIf'
import ShapeCheckBoxAgency from 'src/components/AgencyTabList/ShapeCheckBoxAgency'
import ShapeLogoAgency from 'src/components/AgencyTabList/ShapeLogoAgency'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import ShapeLogoSplitAgency from 'src/components/AgencyTabList/ShapeLogoSplitAgency'

const AgencyTabList = (
  props: Pick<DefaultJoinFormPageProps, 'resetFormItems' | 'blockTelList'> &
    Pick<UIInfoSpace.UIDataType, 'layoutsInsert'>,
) => {
  const { form } = useParamsList()
  const { layoutsInsert } = props
  const shape = layoutsInsert?.agency?.shape || 'logo'
  const isSplitForm = form === 'rop03' || form === 'rop04'

  return (
    <>
      <RenderIf when={!isSplitForm}>
        <RenderIf when={shape === 'logo'}>
          <ShapeLogoAgency {...props} />
        </RenderIf>
        <RenderIf when={shape === 'checkbox'}>
          <ShapeCheckBoxAgency {...props} />
        </RenderIf>
      </RenderIf>
      <RenderIf when={isSplitForm}>
        <ShapeLogoSplitAgency {...props} />
      </RenderIf>
    </>
  )
}

export default AgencyTabList
